import { render, staticRenderFns } from "./MailingNew.vue?vue&type=template&id=15fbea0b&scoped=true&"
import script from "./MailingNew.vue?vue&type=script&lang=js&"
export * from "./MailingNew.vue?vue&type=script&lang=js&"
import style0 from "./MailingNew.vue?vue&type=style&index=0&id=15fbea0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbea0b",
  null
  
)

export default component.exports